import styled from "styled-components";
import {
  NOTICE,
  NOTICE_LIGHTEST,
  TEXT_SECONDARY
} from "@streeteasy/design-system/colors";
import { Caption } from "@streeteasy/design-system/typography";

export const Text = styled(Caption)`
  color: ${TEXT_SECONDARY};
  padding-bottom: 20px;
`;

export const CTAButton = styled(Caption).attrs({
  as: "button",
  type: "button"
})`
  background: 0;
  border: 0;
  border-bottom: 1px solid ${TEXT_SECONDARY};
  color: ${TEXT_SECONDARY};
  padding: 0;

  &:focus,
  &:hover {
    background-color: ${NOTICE_LIGHTEST};
    border-bottom: 1px solid ${NOTICE};
    color: ${NOTICE};
    fill: ${NOTICE};
  }
`;
